<template>
  <card id="gatewayConfigurationClock" :title="$t('gc-clock:clock')">
    <div slot="card-body">
      <div class="form-row">
        <div class="form-group col-lg-6">
          <label for="ntp1" class="control-label">{{ $t('gc-clock:ntp1Address') | capitalize }}</label>
          <input id="ntp1"
                 v-model="clock.ntp1"
                 v-validate="'url'"
                 :disabled="disabled"
                 :data-vv-as="$t('gc-clock:ntp1Address')"
                 :class="{ 'is-invalid': errors.has('ntp1') }"
                 type="text"
                 name="ntp1"
                 class="form-control"
          >
          <div class="invalid-feedback">{{ errors.first('ntp1') }}</div>
        </div>

        <div class="form-group col-lg-6">
          <label for="ntp2" class="control-label">{{ $t('gc-clock:ntp2Address') | capitalize }}</label>
          <input id="ntp2"
                 v-model="clock.ntp2"
                 v-validate="'url'"
                 :disabled="disabled"
                 :data-vv-as="$t('gc-clock:ntp2Address')"
                 :class="{ 'is-invalid': errors.has('ntp2') }"
                 type="text"
                 name="ntp2"
                 class="form-control"
          >
          <div class="invalid-feedback">{{ errors.first('ntp2') }}</div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-lg-6">
          <label for="periodResolution" class="control-label">{{ $t('gc-clock:period') | capitalize }}</label>
          <select id="periodResolution"
                  v-model="clock.periodResolution"
                  :disabled="disabled"
                  class="form-control"
          >
            <option value="PR16SEC">{{ $t('gc-clock:second', {count: 16}) }}</option>
            <option value="PR1MIN">{{ $t('gc-clock:minute', {count: 1}) }}</option>
            <option value="PR17MIN">{{ $t('gc-clock:minute', {count: 17}) }}</option>
            <option value="PR1HOUR">{{ $t('gc-clock:hour', {count: 1}) }}</option>
            <option value="PR9HOUR">{{ $t('gc-clock:hour', {count: 9}) }}</option>
            <option value="PR18HOUR">{{ $t('gc-clock:hour', {count: 18}) }}</option>
            <option value="PR36HOUR">{{ $t('gc-clock:hour', {count: 36}) }}</option>
          </select>
        </div>
      </div>
    </div>

    <div slot="card-footer">
      <button id="sendButton" :disabled="disabled" class="btn btn-primary" @click="send">{{ $t('gc-clock:send') }}</button>
    </div>
  </card>
</template>

<script>
import { isEmpty, pick } from 'lodash-es'
import { mapGetters } from 'vuex'
import to from '@/modules/await-to-js'
import eventBus from '@/modules/eventBus'

export default {
  titleKey: 'gatewayConfClock',

  props: {
    eui: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      clock: {},
      getting: false,
      sending: false
    }
  },

  computed: {
    ...mapGetters(['gateway']),

    disabled () {
      return isEmpty(this.clock) || this.sending
    }
  },

  watch: {
    eui () {
      // Reset data, and get data from new gateway
      this.clock = {}
    },

    gateway () {
      // Do not refresh is we olready have the data
      if (!isEmpty(this.clock) || this.getting) return

      this.getClock()
    }
  },

  created () {
    this.getClock()
  },

  methods: {
    async getClock () {
      if (isEmpty(this.gateway)) return

      if (!this.gateway.connection) {
        eventBus.$emit('message-info', this.$t('gc-clock:gatewayNotConnected'))
        return
      }

      this.getting = true

      let error, response
      [error, response] = await to(this.$api.getGatewayCurrentConfiguration(this.gateway, { groups: 'time' }))
      if (!error && response) this.clock = response.data

      this.getting = false
    },

    async send () {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      this.sending = true

      // Only NTP
      this.sourceAux = 'NTP'

      const keys = ['sourceAux', 'periodResolution', 'ntp1', 'ntp2']
      let error
      [error] = await to(this.$api.updateGatewayCurrentConfiguration(this.gateway, pick(this.clock, keys)))
      if (!error) eventBus.$emit('message-success', this.$t('gc-clock:sendSuccess'))

      this.sending = false
    }
  }
}
</script>
